<div class="py-40 px-10 text-center text-xl text-bold">
  @if (isLoading) {
    <div class="flex justify-center items-center py-6">
      <i class="icon icon-privacy text-4xl animate-pulse"></i>
    </div>
  }

  <div>
    {{ statusMessage }}
  </div>

  @if (errorMessage) {
    <div class="mt-6 text-center text-base text-error-800">
      {{ errorMessage }}
    </div>
  }

  @if (isOnError) {
    <div class="mt-6 flex flex-row justify-center">
      <app-button-atom
        size="M"
        label="Réessayer"
        (click)="createOrder()"
        type="primary"
      ></app-button-atom>
    </div>
    <div class="mt-4 flex flex-row justify-center">
      <app-button-atom
        size="XS"
        thickSize="S"
        label="Retourner au panier"
        (click)="backToCart()"
        type="light"
      ></app-button-atom>
    </div>
  }
</div>

@if (loadKioskResetTimer) {
  <app-kiosk-cart-reset-timer-block
    [config]="{ 'wait_for_user_interaction_to_display_modal': false }"
  ></app-kiosk-cart-reset-timer-block>
}
